import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";

export async function deleteMessage(args: { penmateId: string; messageId: string }): Promise<void> {
  await pmFetchJson(`/letters/${encodeURIComponent(args.messageId)}`, {
    method: "DELETE",
    params: { penmate_id: args.penmateId },
  });
}

